import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

interface Props {
  height?: string | number;
  title?: string;
  message?: string;
  onRetry?: () => void;
}

function CardError({
  height = "20rem",
  title = "Unable to load data",
  message = "The request failed. Please try again.",
  onRetry,
}: Props): JSX.Element {
  return (
    <Card sx={{ overflow: "hidden", minWidth: 0 }}>
      <MDBox
        p={2}
        minHeight={height}
        width="100%"
        minWidth={0}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <MDBox
          width="3rem"
          height="3rem"
          bgColor="error"
          variant="gradient"
          coloredShadow="error"
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          color="white"
          mb={2}
        >
          <Icon fontSize="medium">error_outline</Icon>
        </MDBox>
        <MDTypography variant="h6" mb={0.5}>
          {title}
        </MDTypography>
        <MDTypography
          variant="body2"
          color="text"
          mb={onRetry ? 2 : 0}
          sx={{
            width: "100%",
            maxWidth: "100%",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
          }}
        >
          {message}
        </MDTypography>
        {onRetry && (
          <MDButton variant="gradient" color="error" size="small" onClick={onRetry}>
            Retry
          </MDButton>
        )}
      </MDBox>
    </Card>
  );
}

export default CardError;
